import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import CategorieActions from './categorieProdottoActions';
import { AppConstants } from '../../constants/AppConstants';
import { isNullOrUndefined } from 'util';
import { resolve } from 'url';
import ApplicationData from '../../app/aApplicationData'
import { isAuth } from 'arm-common/dist/aApplicationData';

class MicroCategorieList extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MicroCategorieList.jsx] ';
        this.createCategoria = this.createCategoria.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'ordVis', title: i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine'), sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            // { field: 'descrizione', title: i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE','Descrizione'), sortable: 'true' },
            { field: 'codAmbito', title: i18n('ARM_CORE_PRODUCT.SHARED.AMBITO', 'Ambito'), sortable: 'true', formatter: this.ambitoFormatter },
            { field: 'idFamigliaProdotto', title: i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto'), sortable: 'true', formatter: this.famigliaProdottoFormatter },
            //{ field: 'codQuestionarioQuotazione', title: i18n('ARM_CORE_PRODUCT.CATEGORIE_PRODOTTO.QST_QUOTAZIONE', 'Qst Quotazione'), sortable: 'true' },
            { field: 'updateUser', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da'), sortable: 'true' },
            { field: 'updateDate', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica'), formatter: this.dateFormatter, sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        //effettuo la chimata rest per recuperare i dati
        this.props.getListCategorie();
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    categoriaProdottoFormatter(value, row, index) {

        console.log("categoriaProdottoFormatter:" + index);
        if (!isNullOrUndefined(row) && !isNullOrUndefined(row.categoriaProdotto)) {
            return row.categoriaProdotto.nome;

        }
        return '-'
    }

    famigliaProdottoFormatter(value, row, index) {

        console.log("famigliaProdottoFormatter:" + index);
        if (!isNullOrUndefined(row) && !isNullOrUndefined(row.famigliaProdotto)) {
            return row.famigliaProdotto.nome;

        }
        return '-'
    }

    ambitoFormatter(value, row, index) {

        console.log("ambitoFormatter:" + index);
        if (!isNullOrUndefined(value)) {
            return ApplicationData.domainVal('AI_AMBITO_RAMO', value, value).desDom
        }
        return "-";
    }

    createCategoria() {
        console.log(this.componentName + "createCategoria  ");
        this.props.inizializzaNuovaCategoria().then(
            resolve => {
                this.props.history.push('/categorie/create');
            }

        )
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    columnDetail(value, row, index) {
        console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/categorie/details', state: { id: row.id } });
    }


    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right" bs='primary' onClick={this.createCategoria} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')} </agui.aButton>
                    }
                    <h3>{i18n('ARM_CORE_PRODUCT.CATEGORIE_PRODOTTO.CATEGORIE_PRODOTTO', 'Categorie Prodotto')}</h3>
                </div>
                <div className="card-body">
                    <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
                </div>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListCategorie() {
            return dispatch(CategorieActions.getListaCategorie());
        },
        inizializzaNuovaCategoria() {
            return dispatch(CategorieActions.inizializzaNuovaCategoria());
        },
    }
};

function mapStateToProps(state) {
    return {
        rows: state.categorieProdotto.listCategorieProdotto
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(MicroCategorieList);
